(function () {
  "use strict";

  function initProductCartBox(el) {
    let cart_form = document.querySelector(
      ".product-single-addtocart-wrapper form.cart , .single-product-add-to-cart-form-widget form.cart",
    );
    if (!cart_form) return;

    let cart_quantity = cart_form.querySelector(".quantity");
    let cart_price = cart_form.querySelector(
      ".woocommerce-variation-price > .price",
    );
    let cart_sku = cart_form.querySelector(".sku");
    let cart_submit = cart_form.querySelector(
      '[type="submit"][name="add-to-cart"], [type="submit"], .single_add_to_cart_button',
    );
    let cart_stock = cart_form.querySelector(".stock");

    let targetQty = el.querySelector(".quantity");
    if (targetQty && cart_quantity) {
      targetQty.innerHTML = cart_quantity.innerHTML;
    }

    if (cart_price) {
      let productPrice = el.querySelector(".product-price");
      let productPriceFragment = document.querySelector(
        ".product-price--fragment",
      );
      if (productPriceFragment) {
        productPriceFragment.innerHTML = cart_price.innerHTML;
      }

      if (productPrice) {
        productPrice.classList.remove("price-updated");
        if (productPrice.innerHTML !== cart_price.innerHTML) {
          productPrice.innerHTML = cart_price.innerHTML;
          setTimeout(() => {
            productPrice.classList.add("price-updated");
          }, 100);
        }
      }
    }

    if (cart_sku) {
      let skuEl = el.querySelector(".sku");
      if (skuEl) skuEl.innerHTML = cart_sku.innerHTML;
    }

    if (cart_submit) {
      let trigger = el.querySelector(".add-to-cart--trigger");
      if (trigger) trigger.textContent = cart_submit.textContent.trim();
    }

    let productStock = el.querySelector(".product-stock");
    if (productStock) {
      if (cart_stock) {
        productStock.innerHTML = cart_stock.innerHTML;
        productStock.style.display = "block";
      } else {
        productStock.innerHTML = "";
        productStock.style.display = "none";
      }
    }

    let trigger = el.querySelector(".add-to-cart--trigger");
    if (trigger) {
      if (
        !cart_submit ||
        cart_submit.classList.contains("disabled") ||
        cart_submit.disabled
      ) {
        trigger.disabled = true;
      } else {
        trigger.disabled = false;
      }
    }
  }

  document.addEventListener("init", function (e) {
    if (e.target.matches && e.target.matches(".product-cart-box")) {
      initProductCartBox(e.target);
    }
  });

  document.addEventListener("click", function (e) {
    const atcTrigger = e.target.closest(".add-to-cart--trigger");
    if (atcTrigger) {
      if (atcTrigger.closest(".product-sidebar-cart-box")) {
        return;
      }
      const realBtn = document.querySelector(
        ".product-single-addtocart-wrapper form.cart .single_add_to_cart_button, .single-product-add-to-cart-form-widget form.cart .single_add_to_cart_button",
      );
      if (realBtn) {
        realBtn.click();
      } else {
        alert("فرم خرید محصول در صفحه پیدا نشد!");
      }
      return;
    }

    const sidebarAtc = e.target.closest(
      ".product-sidebar-cart-box .add-to-cart",
    );
    if (sidebarAtc) {
      e.preventDefault();
      const productHeader = document.querySelector(".product-header");
      if (productHeader) {
        window.scrollTo({
          top: productHeader.getBoundingClientRect().top + window.scrollY - 50,
          behavior: "smooth",
        });
      }
      return;
    }
  });

  document.addEventListener("change", function (e) {
    const qtyInput = e.target.closest(
      ".product-cart-box .product-single-addtocart .quantity .qty",
    );
    if (qtyInput) {
      const realQty = document.querySelector(
        ".product-single-addtocart-wrapper form.cart .qty, .single-product-add-to-cart-form-widget form.cart .qty",
      );
      if (realQty) {
        realQty.value = qtyInput.value;
        realQty.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });

  const triggerInitAll = () => {
    document.querySelectorAll(".product-cart-box").forEach((el) => {
      initProductCartBox(el);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", triggerInitAll);
  } else {
    triggerInitAll();
  }

  if (window.jQuery) {
    window
      .jQuery(document)
      .on(
        "change yith_wccl_change check_variations change.wc-variation-form hide_variation show_variation",
        ".variations_form, form.cart",
        function () {
          triggerInitAll();
        },
      );
  }
})();
